import service from 'axios'
import Qs from 'qs'
import { Toast } from 'vant'
import { asyncCall } from '@/utils/JBFAPPbridge'
var u = navigator.userAgent
var terminal = ''
if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
  terminal = 'Android'
  // eslint-disable-next-line no-extra-boolean-cast
} else if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
  terminal = 'IOS'
}

const axios = service.create({
  withCredentials: true,
  baseURL: window.serverconfig.VUE_APP_HOST
})
// http request 拦截器
axios.interceptors.request.use(
  config => {
    let sourcechannel = window.localStorage.getItem('sourcechannel')
    if (sourcechannel) {
      config.headers['sourcechannel'] = sourcechannel // 让每个请求携带token
      if (sourcechannel === 'JBFAPP') {
        let Authorization = window.localStorage.getItem('Authorization')
        config.headers['Authorization'] = Authorization // 让每个请求携带token
        let deviceId = window.localStorage.getItem('deviceId')
        let deviceName = window.localStorage.getItem('deviceName')
        config.headers['deviceId'] = deviceId // 让每个请求携带token
        config.headers['deviceName'] = deviceName // 让每个请求携带token
      }
    } else {
      config.headers['sourcechannel'] = terminal // 让每个请求携带token
    }
    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    return config
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response && error.response.status) {
      if (error.response.status === 401) {
        let sourcechannel = window.localStorage.getItem('sourcechannel')
        // 如果是京东金融
        if (sourcechannel === 'JDJRAPP') {
          Toast.fail('请先登录！')
          return
        } else if (sourcechannel === 'JBFAPP') {
          // 如果是企业金融IOS
          Toast.fail('请先登录！')
          asyncCall('reLoginAndClosePage')
          return
        } else {
          window.location.href = window.serverconfig.VUE_APP_LOGINURL + window.location.origin + '/mine'
        }
      } else if (error.response.status === 400 || error.response.status === 500) {
        if (error.response.data) {
          Toast.fail(error.response.data.resMsg)
        } else if (error.message) {
          Toast.fail(error.message)
        }
      }
    }
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/utils/http.js